import { useState } from "react";

export default function AccordionItem({ title, children }) {
    const [open, setOpen] = useState(false);

    return (
        <div className="border-b py-3">
            <div
                onClick={() => setOpen(!open)}
                style={{ cursor: "pointer", fontWeight: "600" }}
            >
                <h3>{title}</h3>
            </div>

            {open && (
                <div style={{ marginTop: "8px" }}>
                    {children}
                </div>
            )}
        </div>
    );
}
